import {
    NgModule
} from '@angular/core';
import {
    FormsModule
} from '@angular/forms';
import {
    HttpClientModule
} from '@angular/common/http';
import {
    IonicModule
} from '@ionic/angular';
import {
    IonicStorageModule
} from '@ionic/storage';
import {
    ApperyioModule
} from './scripts/apperyio/apperyio.module';
import {
    ApperyioDeclarablesModule
} from './scripts/apperyio/declarables/apperyio.declarables.module';
import {
    PipesModule
} from './scripts/pipes.module';
import {
    DirectivesModule
} from './scripts/directives.module';
import {
    ComponentsModule
} from './scripts/components.module';
import {
    CustomComponentsModule
} from './scripts/custom-components.module';
import {
    CustomModulesModule
} from './scripts/custom-modules.module';
import {
    Sanitizer
} from '@angular/core';
import {
    NgDompurifySanitizer
} from '@tinkoff/ng-dompurify';
import {
    createTranslateLoader
} from './scripts/apperyio/translate_module';
import {
    HttpClient
} from '@angular/common/http';
import {
    app
} from './app';
import {
    AppRoutingModule
} from './app-routing.module';
import {
    Settings
} from './Settings/Settings';
import {
    ExportedClass as FileReadService
} from './scripts/custom/FileReadService_Impl';
import {
    ExportedClass as FileReadService_Profile
} from './scripts/custom/FileReadService_Impl_Profile';
import {
    ExportedClass as FeedService
} from './scripts/custom/FeedService';
import {
    ExportedClass as UserService
} from './scripts/custom/UserService';
import {
    ExportedClass as CollectionService
} from './scripts/custom/CollectionService';
import {
    ExportedClass as NeurService
} from './scripts/custom/NeurService';
import {
    ExportedClass as TripService
} from './scripts/custom/TripService';
import {
    ExportedClass as GlobalPlaceInfoService
} from './scripts/custom/GlobalPlaceInfoService';
import {
    ExportedClass as WeatherService
} from './scripts/custom/WeatherService';
import {
    ExportedClass as PlaceService
} from './scripts/custom/PlaceService';
import {
    ExportedClass as NeurBackendService
} from './scripts/custom/NeurBackendService';
import {
    Geolocation
} from '@ionic-native/geolocation/ngx';
import {
    File
} from '@ionic-native/file/ngx';
import {
    WebView
} from '@ionic-native/ionic-webview/ngx';
import {
    Device
} from '@ionic-native/device/ngx';
import {
    SplashScreen
} from '@ionic-native/splash-screen/ngx';
import {
    StatusBar
} from '@ionic-native/status-bar/ngx';
import {
    Keyboard
} from '@ionic-native/keyboard/ngx';
import {
    Network
} from '@ionic-native/network/ngx';
import {
    SecureStorage
} from '@ionic-native/secure-storage/ngx';
import {
    BrowserModule,
    HammerModule
} from '@angular/platform-browser';
import * as Hammer from 'hammerjs';
import {
    HammerGestureConfig,
    HAMMER_GESTURE_CONFIG
} from '@angular/platform-browser';
import {
    ScreenOrientation
} from '@ionic-native/screen-orientation/ngx';
import {
    DeviceOrientation,
    DeviceOrientationCompassHeading
} from '@ionic-native/device-orientation/ngx';
import {
    BrowserAnimationsModule
} from '@angular/platform-browser/animations';
import {
    SwiperModule
} from 'swiper/angular';
import {
    NativeGeocoder,
    NativeGeocoderResult,
    NativeGeocoderOptions
} from '@ionic-native/native-geocoder/ngx';
//import { BackgroundGeolocation, BackgroundGeolocationConfig } from '@awesome-cordova-plugins/background-geolocation/ngx';
import {
    BackgroundGeolocation,
    BackgroundGeolocationConfig
} from '@ionic-native/background-geolocation/ngx';
import {
    TranslateModule,
    TranslateLoader
} from '@ngx-translate/core';
( < any > NgDompurifySanitizer.prototype)._sanitize_fn = NgDompurifySanitizer.prototype.sanitize;
NgDompurifySanitizer.prototype.sanitize = function(...args) {
    let value: any = args[1];
    if (value && value.hasOwnProperty("changingThisBreaksApplicationSecurity")) {
        args[1] = value.changingThisBreaksApplicationSecurity
    }
    return this._sanitize_fn(...args);
}
var getIonicModuleConfig, getIonicStorageModuleConfig;
@NgModule({
    declarations: [
        app, Settings
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        IonicModule.forRoot((typeof getIonicModuleConfig === "function")? getIonicModuleConfig(): undefined),
        HttpClientModule,
        ApperyioModule,
        PipesModule,
        DirectivesModule,
        ComponentsModule,
        ApperyioDeclarablesModule,
        CustomComponentsModule,
        CustomModulesModule,
        IonicStorageModule.forRoot((typeof getIonicStorageModuleConfig === "function")? getIonicStorageModuleConfig(): undefined), BrowserModule, HammerModule, SwiperModule, BrowserAnimationsModule, SwiperModule, TranslateModule.forRoot(),
        AppRoutingModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: (createTranslateLoader),
                deps: [HttpClient]
            }
        })
    ],
    bootstrap: [
        app
    ],
    entryComponents: [
        //app
        Settings
    ],
    providers: [
        StatusBar,
        SplashScreen,
        WebView,
        Device,
        Keyboard,
        Network,
        SecureStorage,
        {
            provide: Sanitizer,
            useClass: NgDompurifySanitizer,
        },
        Geolocation,
        ScreenOrientation,
        File,
        FileReadService,
        FileReadService_Profile,
        FeedService,
        UserService,
        CollectionService,
        NeurService,
        TripService,
        GlobalPlaceInfoService,
        WeatherService,
        PlaceService,
        NeurBackendService,
        NativeGeocoder, ScreenOrientation, DeviceOrientation, BackgroundGeolocation
    ]
})
export class AppModule {}